import WidgetModal from './WidgetModal';
import EditWidgetModal from './EditWidgetModal';
import ThemeBuilder from './ThemeBuilder';
import { 
    Text,
    IconButton,
    Tabs,
    TabList, 
    TabPanels, 
    Tab, 
    TabPanel,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';


function EditorControls({ boardData, queues, ccxQueues, setBoardData, symbeeStats}) {
    
    const handleRemove = (target) => {
        let tempBoardData = {...boardData};
        let tempWidgets = [...boardData.widgets];
        
        //trim the widgets array
        for (var t = 0; t < tempWidgets.length; t++) {
            if (tempWidgets[t]['id'] === target) {
              tempWidgets.splice(t, 1);
            } 
        }
        tempBoardData['widgets'] = tempWidgets;
        console.log(tempBoardData);
        
        setBoardData(tempBoardData);
    };
    
    const handleReorder = (target, direction) => {
        let tempBoardData = {...boardData};
        let tempWidgets = [...boardData.widgets];
        
        // Find the index of the target item in the array
        const targetIndex = tempWidgets.findIndex(item => item.id === target);

        // Check if the target item was found
        if (targetIndex === -1) {
            console.log('Target item not found in the array.');
        return;
        }

        // Check if the target item is already at the first or last position
        if ((direction === 'up' && targetIndex === 0) || (direction === 'down' && targetIndex === tempWidgets.length - 1)) {
            console.log('Target item is already at the edge of the array.');
            return;
        }

        // Determine the new index based on the direction
        const newIndex = direction === 'up' ? targetIndex - 1 : targetIndex + 1;

        // Swap the target item with the item at the new index
        [tempWidgets[targetIndex], tempWidgets[newIndex]] = [tempWidgets[newIndex], tempWidgets[targetIndex]];

        tempBoardData['widgets'] = tempWidgets;
        setBoardData(tempBoardData);
        
    };
    
 
    return (
            <Tabs>
                <TabList>
                  <Tab>Widgets</Tab>
                  <Tab>Theme</Tab>

                </TabList>

                    <TabPanels>
                        <TabPanel>
                          {boardData.widgets.map((widget, itx) => {
                            return (
                                <div style={{display: 'flex', FlexDirection: 'row', justifyContent: 'start', alignItems: 'center', borderRadius: '10px', background: '#00A45F', color: 'white', marginLeft: '0.5em', marginRight: '0.5em', marginTop: '0.25em', width: '75%', paddingLeft: '1em', paddingRight: '0.5em'}} key={`layout-item-div-key-${itx}`}>
                                    <span style={{width: '15%'}}>
                                        <img alt='up' src={process.env.PUBLIC_URL + "/images/up.png"} style={{height: '18px'}} onClick={() => handleReorder(widget.id, 'up')} />
                                        <img alt='down' src={process.env.PUBLIC_URL + "/images/down.png"} style={{height: '18px'}} onClick={() => handleReorder(widget.id, 'down')} />
                                    </span>
                                    <span style={{width: '75%'}}>
                                        <Text key={`layout-item-text-key-${itx}`} fontSize='sm'> {widget.name} </Text>
                                    </span>
                                    <span style={{display: 'flex', flexDirection: 'row', width: '10%', justifyContent: 'space-between', marginRight: '1em'}}>
                                        <EditWidgetModal symbeeStats={symbeeStats} queues={queues} ccxQueues={ccxQueues} boardData={boardData} setBoardData={setBoardData} widget={widget}/>
                                        <IconButton aria-label='Remove Item' icon={<CloseIcon size='xs'/>} size='xs' variant='ghost' onClick={() => handleRemove(widget.id)} />
                                    </span>
                                </div>
                                );
                            })}
                           {boardData.widgets.length < 15 ? <WidgetModal symbeeStats={symbeeStats} queues={queues} ccxQueues={ccxQueues} boardData={boardData} setBoardData={setBoardData}/> : null }
                        </TabPanel>
                        <TabPanel>
                            <ThemeBuilder boardData={boardData} setBoardData={setBoardData}/>
                        </TabPanel>
                    </TabPanels>
              </Tabs>
    );
}

export default EditorControls;


//<ThemeBuilder board={boardData} setBoard={setBoardData}/>